import { AxiosError } from 'axios'
import { UseMutationOptions, useMutation } from 'react-query'
import {
  TranslationDictionary,
  pushSuccessNotification,
  useLocale
} from '@plandi/common'

import { useThunkDispatch } from 'src/store'
import { projectsApi } from '../projects.api'
import { FormValuesProjectRequest } from '../projects.types'
import { getPartsForFormattedRequest } from '../projects.utils'
import { useUploadProjectImages } from '../use-upload-project-images'
import { LoadinProgress } from 'src/reducers/actions/LoadingActions'
import { useCallback } from 'react'

export const useMutationSaveDraftProject = (
  translate?: TranslationDictionary['data'],
  options?: UseMutationOptions<unknown, AxiosError, FormValuesProjectRequest>
) => {
  const dispatch = useThunkDispatch()
  const getProjectImages = useUploadProjectImages()
  const onUploadProgress = useCallback(
    (progressEvent: { loaded: number; total: number }) => {
      const percentage = Math.floor(
        (progressEvent.loaded * 100) / progressEvent.total
      )
      dispatch(LoadinProgress(percentage))
    },
    [dispatch]
  )
  const config = { onUploadProgress }
  const locale = useLocale()
  const mutation = useMutation(
    async (requestBody) => {
      const { coverId, imagesId } = await getProjectImages({
        cover: requestBody.cover,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        images: requestBody.images
      })

      return projectsApi.saveDraftProject(
        {
          ...requestBody,
          parts: getPartsForFormattedRequest(requestBody.parts),
          coverId,
          images: imagesId
        },
        locale,
        config
      )
    },
    {
      ...options,
      onSuccess: (experiences, variables, context) => {
        const isPublish = variables.status === 'published'
        const message = isPublish
          ? translate?.['project-published']
          : translate?.['project-saved-successfully']

        dispatch(pushSuccessNotification(message ?? ''))

        options?.onSuccess?.(experiences, variables, context)
      }
    }
  )

  return mutation
}
